module.exports = __webpack_public_path__ + "static/media/amount.0ce10fe3.rar";